//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import axios from 'axios'

export default {
	data() {
		return {
			// Next / prev buttons will alter this offset, which will be used when determining which events index to pair with which displayedEvents index
			activeIndexOffset: 0,

			events: [], // Will contain all events within repeater obtained from ACF, note this array is not for display, but will be trawled through to find the first 4 and last 5 indexes
			displayedEvents: {
				0 : {
					'year' 		: '',
					'title'		: '',
					'content'	: '',
					'image'		: '',
					'init'		: 'Active',
				},

				1 : {
					'year' 		: '',
					'title'		: '',
					'content'	: '',
					'image'		: '',
					'init'		: 'Just beneath actuve',
				},

				2 : {
					'year' 		: '',
					'title'		: '',
					'content'	: '',
					'image'		: '',
					'init'		: 'Second at the bottom',
				},

				3 : {
					'year' 		: '',
					'title'		: '',
					'content'	: '',
					'image'		: '',
					'init'		: 'Very bottom',
				},

				4 : {
					'year' 		: '',
					'title'		: '',
					'content'	: '',
					'image'		: '',
					'init'		: 'Off screen bottom',
				},

				5 : {
					'year' 		: '',
					'title'		: '',
					'content'	: '',
					'image'		: '',
					'init'		: 'Off screen top',
				},

				6 : {
					'year' 		: '',
					'title'		: '',
					'content'	: '',
					'image'		: '',
					'init'		: 'Very top of screen',
				},

				7 : {
					'year' 		: '',
					'title'		: '',
					'content'	: '',
					'image'		: '',
					'init'		: 'Second from top',
				},

				8 : {
					'year' 		: '',
					'title'		: '',
					'content'	: '',
					'image'		: '',
					'init'		: 'Third from top',
				},
			},

			timelineInstance: this.$root.$data.containerId,
		}
	},

	mounted() {
		var pageId = this.$root.$data.pageId;
		var componentIndex = this.$root.$data.componentIndex;
		this.getEvents('components', 'timeline', pageId, componentIndex);
	},

	methods: {

		// Get ACF by field slug and page id
		getEvents(fieldName, component, pageId, componentIndex) {
			let that = this;

			axios.get('/wp-json/wp/v2/get_acf?field=' + fieldName + '&component=' + component + '&page=' + pageId + '&componentIndex=' + componentIndex)
			.then(function (response) {
				var results = response.data;

				that.events = results.events;

				if (that.events) {
					that.formatDisplayedEvents();
				}
			})
			.catch(function (error) {
				console.log(error);
			});
		},

		formatDisplayedEvents() {
			var eventIndex;

			for (var index = 0; index < 9; index++) {
				// Depending on which index we are working with, lets try grab a different element from the 'events array'

				// Assume events populated in ascending order (most recent at bottom of ACF Repeater)
				if (index == 0) {
					// Get the first element from top
					eventIndex = 0 + this.activeIndexOffset;
					this.formatIndividualDisplayedEventArrayItem(index, eventIndex)
				}

				if (index == 1) {
					// Get the second element from top
					eventIndex = 1 + this.activeIndexOffset;
					this.formatIndividualDisplayedEventArrayItem(index, eventIndex)

				}

				if (index == 2) {
					// Get the third element from top
					eventIndex = 2 + this.activeIndexOffset;
					this.formatIndividualDisplayedEventArrayItem(index, eventIndex)

				}

				if (index == 3) {
					// Get the forth element from top
					eventIndex = 3 + this.activeIndexOffset;
					this.formatIndividualDisplayedEventArrayItem(index, eventIndex)

				}

				if (index == 4) {
					// Get the fifth element from top
					eventIndex = 4 + this.activeIndexOffset;
					this.formatIndividualDisplayedEventArrayItem(index, eventIndex)
				}


				// We now need to go in the completely opposite direction, from here on out we are looking for the oldest events within timeline
				if (index == 5) {
					// Get the event which is forth from bottom of index.
					eventIndex = (this.events.length) - 4 + this.activeIndexOffset;
					this.formatIndividualDisplayedEventArrayItem(index, eventIndex)
				}

				if (index == 6) {
					// Get the event which is third from bottom of index.
					eventIndex = (this.events.length) - 3 + this.activeIndexOffset;
					this.formatIndividualDisplayedEventArrayItem(index, eventIndex)
				}

				if (index == 7) {
					// Get the penultimate event in index
					eventIndex = (this.events.length) - 2 + this.activeIndexOffset;
					this.formatIndividualDisplayedEventArrayItem(index, eventIndex)
				}

				if (index == 8) {
					// Get the last event in index
					eventIndex = (this.events.length) - 1 + this.activeIndexOffset;
					this.formatIndividualDisplayedEventArrayItem(index, eventIndex)
				}
			}
		},

		formatIndividualDisplayedEventArrayItem(index, eventIndex) {

			// If event index is a negative number, it means we have fallen off the edge of the stack, so recalculate index by subtracting event index from the total number of entities within that stack. (i.e. we are turning the stack into a circular entity and coming round from the very top of the stack instead.. think of this as turning a flat map into a globe)


			if (eventIndex < 0) {
				eventIndex = this.events.length + eventIndex;
			}

			// An index larger than array.length means an insufficient number of entities within the events resultset, so dont retrieving
			// Instead, set year to null to not show the year within the timeline wheel.
			if ((eventIndex >= 0) && (eventIndex < this.events.length)) {
				this.displayedEvents[index]['year'] 	= this.events[eventIndex].year;
				this.displayedEvents[index]['title'] 	= this.events[eventIndex].title;
				this.displayedEvents[index]['content'] 	= this.events[eventIndex].content;
				this.displayedEvents[index]['image'] 	= this.events[eventIndex].image.sizes['900x1200'];
			} else {
				this.displayedEvents[index]['year'] 	= false;
			}
		},

		toggleNext() {
			this.animateYears('animate-up');
			this.animateImageCurtain(1, 'animate-up');
			this.animateSlideContent();
		},

		togglePrev() {
			this.animateYears('animate-down');
			this.animateImageCurtain(-1, 'animate-down');
			this.animateSlideContent();
		},

		animateImageCurtain(directionalInteger, animationClass) {
			// Close image curtain
			// Handle left/right shift of event array indexes
			// Reopen image curtain
			let that = this;

			jQuery(this.timelineInstance).find('.info--timeline').find('.curtain--slide-to-left').animate({width: '100%'},500, function() {
				that.updateActiveIndexOffset(directionalInteger);
				that.formatDisplayedEvents();

				jQuery('.timeline-year').each(function() {
					jQuery(this).removeClass(animationClass);
				});
			});

			jQuery(this.timelineInstance).find('.info--timeline').find('.curtain--slide-to-left').animate({width: '0'},500);
		},

		animateSlideContent() {
			var title 	= jQuery(this.timelineInstance).find('.info--timeline').find('.content').find('.text').find('.title-line-1');
			var content = jQuery(this.timelineInstance).find('.info--timeline').find('.content').find('.text').find('.paragraph-container');

			title.animate({opacity: '0'}, 'slow', function() {
				title.animate({opacity: '1'}, 'fast');
			});

			content.animate({opacity: '0'}, 'slow', function() {
				content.animate({opacity: '1'}, 'fast');
			});
		},

		animateYears(animationClass) {
			jQuery(this.timelineInstance).find('.timeline-year').each(function() {
				jQuery(this).addClass(animationClass);
			});
		},

		updateActiveIndexOffset(directionalInteger) {
			this.activeIndexOffset = this.activeIndexOffset + directionalInteger;

			// Reset offset value if it is greater than the absolute value of the events Array length
			// i.e. if there are 3 events, and indexoffset hits -3, reset back to 0

			if ((this.activeIndexOffset < 0) && (this.activeIndexOffset <= (-1 * this.events.length))) {
				this.activeIndexOffset = 0;
			}

			if (this.activeIndexOffset > 0) {
				this.activeIndexOffset = this.activeIndexOffset - this.events.length;
			}
		},
	},
}



// WEBPACK FOOTER //
// ./scripts/vue/timeline.vue